export enum Permission {
  // Revisit the permissions for this domain
  MarketingToolingViewAccess = 'retailer_funded_marketing_retailer_funded_marketing.view',
  MarketingToolingModifyAccess = 'retailer_funded_marketing_retailer_funded_marketing.modify',
  MarketingToolingAdminAccess = 'retailer_funded_marketing_retailer_funded_marketing.admin',
  MarketingToolingEngineeringAccess = 'retailer_funded_marketing.engineering_only_features',
  OffersToolingAdminAccess = 'offers_tooling.admin',
  OffersToolingModifyAccess = 'offers_tooling.modify',
  OffersToolingApproverPermissionHighRisk = 'offers_tooling.approver_permission_high_risk',
  RetailerFundedMarketingCrmCampaignsModifyAccess = 'retailer_funded_marketing_crm_campaigns.modify',
  RouletteApiViewAccess = 'roulette_api_access.view',
}
